import type { OrgUnitElevation } from '@pams/shared';
import { ORG_UNIT_ELEVATION_LABEL } from '@/lib/labels';

/**
 * [C5c §11] The one sentence for a unit's nodal access level — the mark's accessible name and
 * title, the Organisation page's choices and the Officers drawer's readout all read it, so the
 * three cannot word one setting three ways. `actingAt` is the ancestor's NAME, when known.
 */
export const elevationSentence = (elevation: OrgUnitElevation, actingAt?: string): string =>
  elevation === 'NONE'
    ? ORG_UNIT_ELEVATION_LABEL.NONE
    : `${ORG_UNIT_ELEVATION_LABEL[elevation]}${actingAt ? ` — acts at ${actingAt}` : ''}`;
